module.exports = __webpack_public_path__ + "img/service_unavailable.5f8653ad.svg";